"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;
exports.default = exports.WarningButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _reactRouterDom = require("react-router-dom");
var _colors = _interopRequireDefault(require("@material-ui/core/colors"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
const _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */
const useStyles = (0, _styles.makeStyles)(theme => ({
  buttonXl: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));
function Button(props) {
  const classes = useStyles();
  const styledProps = {};
  if (props.color && typeof props.color === 'string' && props.color.indexOf(' ') >= 0) {
    const [clr, hue] = props.color.split(' ');
    styledProps.color = _colors.default[clr] && _colors.default[clr][hue] || 'default';
  }
  if (props.to && !props.component) {
    styledProps.component = _reactRouterDom.Link;
  }
  if (props.size === 'xl') {
    styledProps.size = 'large';
    styledProps.className = props.className ? `${props.className} ${classes.buttonXl}` : classes.buttonXl;
  }
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, props, styledProps));
}
var _default = exports.default = Button;
Button.propTypes = {
  theme: _propTypes.default.object,
  color: _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  href: _propTypes.default.string,
  size: _propTypes.default.string,
  component: _propTypes.default.node,
  to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])
};
Button.defaultProps = {
  color: 'primary',
  size: 'medium',
  component: undefined,
  disabled: undefined,
  fullWidth: undefined,
  href: undefined,
  theme: undefined,
  to: undefined
};
const WarningButton = _ref => {
  let {
      children
    } = _ref,
    next = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Button, _extends({}, next, {
    color: "red 700"
  }), children);
};
exports.WarningButton = WarningButton;
WarningButton.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};
WarningButton.defaultProps = {
  children: []
};
//# sourceMappingURL=Button.js.map